import { environment } from '../../environments/environment';

const BASE_URL = environment.api_url;
export const ARTWORK_CONTROLLER_URL = BASE_URL + "/api/algorithms/artwork";
export const SSE_CONTROLLER_URL = BASE_URL + "/api/sse/connection";
// Set REACT_APP_PRINT_FORMAT_API_URL to hit the local runner in the-generative-project-serverless/local instead
export const PRINT_FORMAT_URL = process.env.REACT_APP_PRINT_FORMAT_API_URL || ARTWORK_CONTROLLER_URL + "/printFormat";
// Set REACT_APP_SHIPPING_QUOTE_API_URL to hit the same local runner
export const SHIPPING_QUOTE_URL = process.env.REACT_APP_SHIPPING_QUOTE_API_URL || ARTWORK_CONTROLLER_URL + "/shippingQuote";
export const PLACE_ORDER_URL = process.env.REACT_APP_PLACE_ORDER_API_URL || ARTWORK_CONTROLLER_URL + "/placeOrder";